<script setup lang="ts">
type LogoSize = 'md';
const { theme = 'light', size = 'md' } = defineProps<{
  size?: LogoSize;
  theme?: 'light' | 'dark';
}>();
</script>

<template>
  <img
    src="/images/logo.webp"
    :class="{
      'h-r12 sm:h-r16 lg:h-r18': size === 'md',
      'brightness-0 invert': theme === 'dark',
    }"
    class="aspect-5/2"
  />
</template>
